import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class DivisionManagementService {
  headers: HttpHeaders;
  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
  }

  getAllDivision() {
    return this.http.get<any>('DivisionManagement/GetAllDivision')
  }

  addEditDivision(data) {        
    return this.http.post<any>('DivisionManagement/AddEditDivision', data)
  }

  deleteDivision(id, isDelete, flag) {
    return this.http.get<any>('DivisionManagement/DeleteDivision?DivisionId=' + id + '&isDelete=' + isDelete + '&flag=' + flag)
  }

  GetDivisionById(DivisionId) {
    return this.http.get('DivisionManagement/GetItemByDivisionId?DivisionId=' + DivisionId);
  }

  GetJobAndTaskList() {
    return this.http.get<any[]>('DivisionManagement/GetJobAndTaskList' );
  }

  getAllActiveDivision() {
    return this.http.get<any>('DivisionManagement/GetAllActiveDivision', { headers: this.headers });
  }

  GetAllBillingEntitiesforselect(IsArchived) {
    return this.http.get<any>('BillingEntity/GetAllBillingEntitiesforselect?IsArchived=' + IsArchived);
  }
}
